export default __webpack_public_path__ + "static/media/books_1.eca43e6f.svg";